// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6294":"7fe95281","7505":"33ba8682","8665":"cc00fa56"}[chunkId] + ".chunk.css";
};